import React, { useState, useEffect } from 'react'

// react redux
import { connect } from "react-redux";

// bootstrap
import { Image } from 'react-bootstrap';

// react router
import { useHistory } from 'react-router-dom';

// react slick
import Slider from "react-slick";

// react toastify
import { toast } from "react-toastify";

// slider images
import sliderImg1 from 'assets/images/sliders/1.jpg'

// actions
import { setGlobalLoading } from 'redux/actions/actionCommon';

// API
import { getHomeSliderImages } from 'utlis/Apis/common_API';

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED,
} from "utlis/AppMessages/AppMessages";

function SliderComponent(props) {
	// props
	const { commonToken } = props
	// refs
	// let slider = useRef(null);

	const [sliders, setSliders] = useState([sliderImg1])

	// consts
	const history = useHistory()

	// useEffect(() => {
	// 	// global loading
	// 	setGlobalLoading(true)

	// 	// fetching data
	// 	getHomeSliderImages(commonToken).then(res => {
	// 		const resData = res.data

	// 		console.log("resData ", resData);

	// 		// if success
	// 		if(resData.success) {
	// 			setSliders([sliderImg1])
	// 		}

	// 		// if error
	// 		if(resData.error) {
	// 			// dismissing all the previous toasts first
	// 			toast.dismiss();

	// 			// showing the message
	// 			toast.error(resData.message || UNKNOWN_ERROR_OCCURED, {
	// 				autoClose: 2000,
	// 			});
	// 		}
	// 	}).catch(err => {
	// 		console.log(`${ERROR_WHILE__NAME} getHomeSliderImages `, err.message);

	// 		// dismissing all the previous toasts first
	// 		toast.dismiss();

	// 		// showing the error message
	// 		toast.error(UNKNOWN_ERROR_OCCURED, {
	// 			autoClose: 2500,
	// 			onClose: () => {
	// 				// global loading
	// 				setGlobalLoading(false)
	// 			},
	// 		});
	// 	})


	// }, [commonToken])

	// handle route
    const handleRoute = (ev, url) => {
        ev.preventDefault()

        history.push({
			pathname: url
		})
    }

	return (
		<div className="slider-container-outer mb-3 mb-lg-5" id="home-slider">
			<div className="slider-container position-relative overflow-hidden">
				<Slider
					// ref={(c) => (slider = c)}
					dots={false}
					speed={500}
					slidesToShow={1}
					slidesToScroll={1}
					arrows={false}
					autoPlay={true}
					autoplaySpeed={1000}
					draggable={false}
				>
					{
						/* slider item */
						sliders?.length ? sliders.map((item, index) => (
							<a 	
								key={index}
								href="/"
								className="slider-item cursor-pointer"
								onClick={ev => handleRoute(ev, "/category/outdoor-garden?id=16")}>
								<Image src={item} alt="slider-img" fluid className="w-100" />
							</a>
						)) : null
					}
				</Slider>

				{/* slider buttons */}
				{/* <div className="slider-buttons">
					<a href="/" className="icon position-absolute left" onClick={ev => {
						ev.preventDefault()

						slider.slickPrev()
					}}>
						<BsChevronLeft fontSize="26" />
					</a>
					<a href="/" className="icon position-absolute right" onClick={ev => {
						ev.preventDefault()

						slider.slickNext()
					}}>
						<BsChevronRight fontSize="26" />
					</a>
				</div> */}
			</div>
		</div>

	)
}


const getDataFromStore = (state) => {
    return {
        commonToken: state.auth.commonToken,
    };
};

const dispatchActionsToProps = (dispatch) => {
    return {
		setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
	};
};

export default connect(getDataFromStore, dispatchActionsToProps)(SliderComponent);